/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Closedeal_Card_Title2Inputs */

const en_coinvestments_closedeal_card_title2 = /** @type {(inputs: Coinvestments_Closedeal_Card_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close this deal`)
};

/**
* | output |
* | --- |
* | "Close this deal" |
*
* @param {Coinvestments_Closedeal_Card_Title2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_closedeal_card_title2 = /** @type {((inputs?: Coinvestments_Closedeal_Card_Title2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Closedeal_Card_Title2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_closedeal_card_title2(inputs)
});
export { coinvestments_closedeal_card_title2 as "coInvestments_closeDeal_card_title" }